import { Pipe, PipeTransform } from '@angular/core';

    @Pipe({
        name: 'thousandsPipe',
        //pure: false
    })

export class ThousandsPipe implements PipeTransform {

    public transform(value: any) {
      if (value != null && value != undefined &&  !Number.isNaN(value)){
        value = value.toString();
        for (let i = 0; i < value.length; i++) {
          if(value.indexOf('.') > 0){
            value = value.replace(".","");
          }
        }
        /*value = value.replace(".","");
        value = value.replace(".","");
        value = value.replace(".","");*/

        value = value.replace("$","");
        value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return "$"+value ;
      }else{
        //return 0;
      }

    }
}
